import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlert = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 9.25v-3.5m0 8.5v-1.5m1.191 4.745 6.304-6.304c.417-.417.625-.625.703-.866.07-.211.07-.439 0-.65-.078-.24-.286-.45-.703-.866L11.19 2.505c-.417-.417-.625-.625-.866-.703a1.053 1.053 0 0 0-.65 0c-.24.078-.45.286-.866.703L2.505 8.81c-.417.417-.625.625-.703.866-.07.211-.07.439 0 .65.078.24.286.45.703.866l6.304 6.304c.417.417.625.625.866.703.211.07.439.07.65 0 .24-.078.45-.286.866-.703Z"
	})]
});
const ForwardRef = forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
